import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import Input from "@streeteasy/design-system/deprecated/Input";

const { Caps, H2, P } = typography;
const { LARGE_SCREEN } = screenSizes;
const { ERROR, GRAY_LIGHT, TEXT_SECONDARY } = colors;

export const Content = styled.div`
  padding: 70px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    padding: 40px 52px 74px;
  }
`;

export const ErrorText = styled(P)`
  color: ${ERROR};
  font-weight: 400;
  margin-top: 3px;
  text-transform: none;
`;

export const FormDescription = styled(P)`
  margin-bottom: 20px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
  }
`;

export const FormTextInput = styled(Input)`
  margin-top: 5px;
`;

export const FormTitle = styled(H2)`
  margin-bottom: 15px;
`;

export const Label = styled(Caps).attrs({
  as: "label"
})`
  color: ${TEXT_SECONDARY};
  display: block;
  margin: 0 0 16px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 14px;
    margin: 0 0 20px;
  }
`;

export const Spacer = styled.div`
  border-bottom: 1px solid ${GRAY_LIGHT};
  height: 1px;
  margin: 40px 0 20px;
`;
